import axios from 'axios'

export const api = axios.create({
    // baseURL: 'http://localhost:3000/api',
    baseURL:' https://academia.gazin.ai/api/v1'
})

// Injeta token em todas as requisições
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
})

// Redireciona para login se token expirar
api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            window.location.href = '/login'
        }
        return Promise.reject(err)
    }
)